import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { UserSettingsModels } from '@share-models';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import { EnableEscCloseDirective, UiButtonComponent } from '@ui';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';

@Component({
  selector: 'app-change-user-language-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogClose,
    TranslatePipe,
    MatRadioButton,
    MatRadioGroup,
    UiButtonComponent,
  ],
  templateUrl: './change-user-language-modal.component.html',
  styleUrl: './change-user-language-modal.component.scss',
  hostDirectives: [EnableEscCloseDirective],
})
export class ChangeUserLanguageModalComponent implements OnInit {
  public userLangFormControl = new FormControl<string>('', [
    Validators.required.bind(Validators),
  ]);
  public langString = UserSettingsModels.langString;
  public language = {
    ENGLISH: 'en',
    SPANISH: 'es',
    HEBREW: 'he',
    JAPANESE: 'ja',
  } as const;

  private dialogRef = inject(MatDialogRef<ChangeUserLanguageModalComponent>);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  public data = inject<{
    settings: UserSettingsModels.UserSettingsDocument;
    defaultOrgLang?: string;
  }>(MAT_DIALOG_DATA);

  public ngOnInit(): void {
    this.userLangFormControl.patchValue(
      this.data?.settings?.lang ??
        this.data?.defaultOrgLang ??
        this.language.ENGLISH,
    );
  }

  public close(): void {
    this.dialogRef.close();
  }

  public save(): void {
    const formValue = this.userLangFormControl.value?.trim();
    if (!formValue) {
      return;
    }

    this.store$.dispatch(
      UserSettingsActions.startUpdateLanguage({ lang: formValue }),
    );
    this.dialogRef.close();
  }
}
